
import { Bay } from "./bay";
import FirestoreModel from "../FirestoreModel";
import { DateTime } from "luxon";


export class Slot extends FirestoreModel<Slot>() {

  static timeFormat = "yyyy-LL-dd'T'HH:mm:ss";

  static collectionPath = (companyId: string, locationId: string, bayId: string) => [...Bay.refPath(companyId, locationId, bayId), "slots"];
  static refPath = (companyId: string, locationId: string, bayId: string, slotId: string) => [...this.collectionPath(companyId, locationId, bayId), slotId];
  static collection(companyId: string, locationId: string, bayId: string) {
    return this.pathToCollection(this.collectionPath(companyId, locationId, bayId));
  }
  static ref(companyId: string, locationId: string, bayId: string, slotId: string) {
    return super.pathToRef(this.refPath(companyId, locationId, bayId, slotId));
  }

  time: DateTime | null;
  date: DateTime | null;
  private fields: any;


  constructor(snapshot: any) {
    super(snapshot);
    const data = snapshot.data();
    this.time = data.time ? DateTime.fromMillis(data.time.toMillis()).toUTC() : null;
    this.date = data.date ? DateTime.fromMillis(data.date.toMillis()).toUTC() : null;
    this.fields = data;
  }

  isTimeTaken(time: DateTime<true>) {
    return !!this.fields[time.toFormat(Slot.timeFormat)]
  }
}